module.exports = __webpack_public_path__ + "statics/img/5-3.2c5f2f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/5-3.png
// module id = eMuF
// module chunks = 1